import axios from 'axios';
import { API_BASE_URL } from '../config/env.js';

const apiClient = axios.create({
  baseURL: API_BASE_URL, 
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer token-de-acceso',
  },
  validateStatus: function (status) {
    return (status >= 200 && status < 300) || status === 204;
  },
});


apiClient.interceptors.response.use(
  response => {
    const contentType = response?.headers?.['content-type'];
    if (response?.status !== 204 && contentType && contentType.includes('text/html')) {
      return Promise.reject(new Error('La respuesta del servidor es HTML en lugar de JSON. Esto indica que la variable REACT_APP_API_BASE_URL no está configurada o es incorrecta en producción, haciendo que las peticiones apunten al frontend y Nginx retorne el index.html.'));
    }
    return response;
  },
  error => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default apiClient;
